import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {getLogs} from '../store/teachActions';
import TeachLogFilter from './TeachLogFilter';
import LogContent from './LogContent';

const TeachActionLogs = ({logs,logfiltered,getLogs}) => {
  const [show, setShow] = useState(false);

  useEffect(()=>{
    setTimeout(()=>setShow(true),500);
  //eslint-disable-next-line
  },[show]);

  useEffect(()=>{
    getLogs();
  //eslint-disable-next-line
  },[]);

  return (
    <>
      { !show
        ? <div className='progress valign-wrapper'> <div className='indeterminate'></div></div> 
        : <>
            <TeachLogFilter />
            <div className='container col s8'>
              <ul className='collection'>
                { logs!=null && logs.length>0 
                  ? logfiltered !== null
                    ? <LogContent log={logfiltered} />
                    : <LogContent log={logs} />
                  : <p>logs empty</p>
                }
              </ul>
            </div>
          </>
      }
    </>
  );
};

const matStoreToProps = state => ({
  logs: state.teach.logs,
  logfiltered: state.teach.logfiltered
});

export default connect(matStoreToProps,{getLogs})(TeachActionLogs);
